<template>
  <div>
    <el-form-item label="公告：" label-width="110px">
      <draggable :options="{disabled:disabled}" v-model="config[field.key]">
        <el-row class="notice-board" v-for="(item,index) in config[field.key]" :key="index">
          <el-input clearable v-model="config[field.key][index]['content']" placeholder="请输入公告内容" @focus='focus' @blur='blur' :maxlength="50"></el-input>
          <p class="memo">公告内容最多50个汉字</p>
          <el-row>
            <div class="link-name" v-text="config[field.key][index]['link_name']"></div>
            <el-button size="mini" @click="openDialog(index)" v-text="config[field.key][index]['link_name'] ? '更换链接' : '请选择链接'"></el-button>
            <el-button v-if="config[field.key][index]['link_name']" size="mini" class="clear-link" @click="clearLink(index)">清除链接
            </el-button>
          </el-row>
          <!-- 店铺地址对话框 -->
          <el-dialog title="请选择链接" :visible.sync="dialog.visible" @close='closeDialog'>
            <helper @select="select" @close='closeDialog'></helper>
          </el-dialog>
          <i class="el-icon-circle-close-outline" @click="removeNoticeBoard(index)"></i>
        </el-row>
      </draggable>
      <el-button size="mini" @click="addNoticeBoard()">添加公告</el-button>
    </el-form-item>
  </div>
</template>

<style lang="scss" scoped>
.notice-board {
    position: relative;
    border: 1px solid #e3e7ee;
    background-color: #f9f9f9;
    border-radius: 4px;
    padding: 16px;
    margin-bottom: 20px;
    .el-icon-circle-close-outline {
        font-size: 18px;
        position: absolute;
        top: -9px;
        right: -9px;
        background: #fff;
        cursor: pointer;
    }
}
.radio-item {
    padding-right: 20px;
}

.memo {
    color: #c5c5c5;
    line-height: 30px;
    margin-bottom: 0px;
    font-size: 14px;
}
</style>

<script>
import draggable from 'vuedraggable';

export default {
    name: 'tms-type-notice-board',
    props: {
        field: {
            type: [Object, Array],
            required: true,
        },
        config: {
            type: Object,
            default() {
                return {};
            },
        },
    },
    data() {
        return {
            dialog: {
                visible: false,
            },
            disabled: true,
            currentIndex: 0,
        };
    },

    components: {
        draggable,
    },

    mounted() {},

    methods: {
        focus() {
          this.disabled = true;
        },
        blur() {
          this.disabled = false;
        },
        clearLink(index) {
            delete this.config[this.field.key][index].link_name;
            delete this.config[this.field.key][index].link_data;
            delete this.config[this.field.key][index].link_type;
            let temp = this.config[this.field.key][index];
            this.config[this.field.key].splice(index, 1, temp);
        },
        openDialog(index) {
            this.currentIndex = index;
            this.dialog.visible = true;
        },
        closeDialog() {
            this.dialog.visible = false;
        },
        select(link, linkName, linkType) {
            this.config[this.field.key][this.currentIndex].link_name = linkName;
            this.config[this.field.key][this.currentIndex].link_data = link;
            this.config[this.field.key][this.currentIndex].link_type = linkType;
            this.dialog.visible = false;
        },
        addNoticeBoard() {
            if (this.config[this.field.key].length < 5) {
                this.config[this.field.key].push({});
            } else {
                this.$message.error('最多添加5条公告');
            }
        },
        removeNoticeBoard(index) {
            this.config[this.field.key].splice(index, 1);
        },
    },
};
</script>
